export var workerErrorProp = function (error, errorId) {
    return {
        name: error.name,
        message: error.message,
        stack: error.stack,
        errorId: errorId,
    };
};
export var workerErrorPropToError = function (errorProp) {
    var error = new Error();
    error.name = errorProp.name;
    error.message = errorProp.message;
    error.stack = errorProp.stack;
    return { error: error, errorId: errorProp.errorId };
};
//# sourceMappingURL=workerErrorProp.js.map